import { render, staticRenderFns } from "./MenuTabAbout.vue?vue&type=template&id=7c0495f8&"
import script from "./MenuTabAbout.vue?vue&type=script&lang=js&"
export * from "./MenuTabAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports